import { useEffect } from 'react';
import { StatusBar, Style } from '@capacitor/status-bar';
import { isNative } from './platform';

/**
 * Dark status bar icons, for the white pages and loaders most of the app shows. Set on every page
 * load: a reload keeps the native style the last page set, and the configured one applies only at
 * app start. A failure only leaves the icons' colour as it was, so it is not reported.
 */
export const setDefaultStatusBarStyle = (): void => {
    if (isNative()) void StatusBar.setStyle({ style: Style.Light });
};

let brandGrounds = 0;

/** Light status bar icons while the brand-coloured ground behind them is mounted. */
export const useBrandStatusBar = (onBrand = true): void => {
    useEffect(() => {
        if (!isNative() || !onBrand) return undefined;
        brandGrounds += 1;
        void StatusBar.setStyle({ style: Style.Dark });
        return () => {
            brandGrounds -= 1;
            // Deferred past the commit: a page on the same ground taking over (login to recover
            // password) mounts in it, and resetting first would flash the icons, animated on iOS.
            queueMicrotask(() => {
                if (brandGrounds === 0) setDefaultStatusBarStyle();
            });
        };
    }, [onBrand]);
};
